import { useNavigate } from "@tanstack/react-router";
import { IconArrowRight, IconCircleDashed } from "@tabler/icons-react";
import { Button, Card, Group, Heading, Stack, Text, ThemeIcon } from "@/components/ui";

/** Card del tab Resumen cuando todavía no se cargó CFDI · CTA a /cargar-cfdi. */
export function CfdiAusenteCard({ solicitudId }: { solicitudId: string }) {
  const navigate = useNavigate();
  return (
    <Card>
      <Stack gap="md">
        <Group gap="sm">
          <ThemeIcon variant="filled" color="multiva" size="md" radius="md">
            <IconCircleDashed size={16} />
          </ThemeIcon>
          <Stack gap={0}>
            <Heading order={5}>CFDI no cargado aún</Heading>
            <Text size="xs" c="dimmed">
              Sube el archivo XML del CFDI 4.0 para iniciar la validación.
            </Text>
          </Stack>
        </Group>
        <Button
          rightSection={<IconArrowRight size={14} />}
          onClick={() =>
            navigate({
              to: "/solicitudes/$id/cargar-cfdi",
              params: { id: solicitudId },
              replace: true,
            })
          }
        >
          Cargar CFDI
        </Button>
      </Stack>
    </Card>
  );
}
